import { apiClient } from '@/lib/api-client';
import type { ModelDescriptor } from '../types';

export async function loadModels(): Promise<ModelDescriptor[]> {
  const res = await apiClient.get<{ data: ModelDescriptor[] }>('/api/v1/inferences/models');
  return res.data.data ?? [];
}
